import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useLatest } from 'react-use';
import styled from 'styled-components';
import { useHapticFeedback } from '@blade/ui-kit';
import { SegmentedControlContext, } from './segment-control-context';
import { SegmentControlItem } from './segment-control-item';
export const SegmentControl = ({ value, onChange, children, className, getId, disabled, size = 'h36', }) => {
    const haptics = useHapticFeedback();
    const onChangeRef = useLatest(onChange);
    const ctx = useMemo(() => ({
        value: value,
        getId: getId ? (value) => getId(value) : undefined,
        onChange: (value) => {
            if (onChangeRef.current) {
                haptics.impactOccurred('light');
                onChangeRef.current?.(value);
            }
        },
    }), [value, getId, haptics, onChangeRef]);
    return (_jsx(Root, { className: className, "aria-disabled": disabled, "data-size": size, children: _jsx(SegmentedControlContext.Provider, { value: ctx, children: children }) }));
};
SegmentControl.Item = SegmentControlItem;
const Root = styled.div `
  padding: 3px;

  display: inline-flex;
  align-items: stretch;
  overflow: hidden;

  height: 36px;
  border-radius: 20px;
  background: var(--appearanceA-4);
  gap: 1px;

  &[data-size='h30'] {
    --segment-control-height: 30px;
    --segment-control-item-padding-inline: 12px;
    --segment-control-item-radius: 15px;
  }
  &[data-size='h36'] {
    --segment-control-height: 36px;
    --segment-control-item-padding-inline: 12px;
    --segment-control-item-radius: 15px;
  }
  &[data-size='h38'] {
    --segment-control-height: 38px;
    --segment-control-item-padding-inline: 12px;
    --segment-control-item-radius: 15px;
  }
  &[data-size='h42'] {
    --segment-control-height: 42px;
    --segment-control-item-padding-inline: 18px;
    --segment-control-item-radius: 20px;
  }
  &[data-size='h46'] {
    --segment-control-height: 46px;
    --segment-control-item-padding-inline: 20px;
    --segment-control-item-radius: 24px;
  }
  &[data-size='h50'] {
    --segment-control-height: 50px;
    --segment-control-item-padding-inline: 20px;
    --segment-control-item-radius: 24px;
  }

  height: var(--segment-control-height);
`;
//# sourceMappingURL=segment-control.js.map